import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ContabilizadorRecontabilizador from './ContabilizadorRecontabilizador.jsx';
import * as actions from '../actions/Actions.js';

const mapStateToProps = (state) => {
    return {
        data: state.contabilizadorRecontabilizador,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch) => { return { actions: bindActionCreators(actions, dispatch) } }

const ContabilizadorRecontabilizadorContainer = connect(mapStateToProps, mapDispatchToProps)(ContabilizadorRecontabilizador);


export default ContabilizadorRecontabilizadorContainer;